import { IMyDayLabels } from './my-day-labels.interface';
import { IMyMonthLabels } from './my-month-labels.interface';
import { IMyDate } from './my-date.interface';
import { IMyDateRange } from './my-date-range.interface';
import { IMyMarkedDates } from './my-marked-dates.interface';
import { IMyMarkedDate } from './my-marked-date.interface';
import { IMyStyles } from './my-styles.interface';
import { DefaultView } from '../enums/default-view.enum';
import { Year } from '../enums/year.enum';
import { IMyShortcuts } from './my-shortcuts.interface';
import { ShowType } from '../enums/show-type.enum';
import { DynamicData } from './dynamic-data-type.interface';


export interface IMyOptions {
    dateRange?: boolean;
    showTime?: boolean;
    showType?: ShowType;
    dayLabels?: IMyDayLabels;
    monthLabels?: IMyMonthLabels;
    yearTxt?: string;
    dateFormat?: string;
    defaultView?: DefaultView;
    /** æ¯å¨èµ·å§æ¥  å¯éå¼ moï¼å¨ä¸,  su: å¨æ¥ï¼é»è®¤ä¸º moå¨ä¸ */
    firstDayOfWeek?: string;
    satHighlight?: boolean;
    sunHighlight?: boolean;
    highlightDates?: Array<IMyDate>;
    markCurrentDay?: boolean;
    markCurrentMonth?: boolean;
    markCurrentYear?: boolean;
    monthSelector?: boolean;
    yearSelector?: boolean;
    disableHeaderButtons?: boolean;
    showWeekNumbers?: boolean;
    selectorHeight?: string;
    selectorWidth?: string;
    disableUntil?: IMyDate;
    disableSince?: IMyDate;
    disableDates?: Array<IMyDate>;
    disableDateRanges?: Array<IMyDateRange>;
    disableWeekends?: boolean;
    disableWeekdays?: Array<string>;
    enableDates?: Array<IMyDate>;
    markDates?: Array<IMyMarkedDates>;
    markWeekends?: IMyMarkedDate;
    closeSelectorOnDateSelect?: boolean;
    closeSelectorOnDocumentClick?: boolean;
    minYear?: Year;
    maxYear?: Year;
    focusInputOnDateSelect?: boolean;
    moveFocusByArrowKeys?: boolean;
    dateRangeDatesDelimiter?: string;
    inputFieldValidation?: boolean;
    stylesData?: IMyStyles;
    ariaLabelPrevMonth?: string;
    ariaLabelNextMonth?: string;
    shortcuts?: Array<IMyShortcuts>;
    timeBtnText?: string;
    dateBtnText?: string;
    commitBtnText?: string;
    weekText?: string;
    returnFormat?: string;
    placeholder?: string;
    timeFormat?: string;
    range?: any;
    monthRangeValue?: number;
    message?: any;
   
    viewType?: ViewType | string;
    enableDynamic?: boolean;
    showDynamicView?: boolean;
    dynamicValue?: DynamicData;
    // å¨ææ¥æåéæ´æ°
    dynamicValueChanged?: (e: {text: string, value: {}}) => void;
    /** å¨ææ¥æï¼è¿å»æ¶é´æå¤§å¤©æ° */
    previousMaxDays?: number;
    /** å¨ææ¥æï¼æªæ¥æ¥ææå¤§å¤©æ° */
    futureMaxDays?: number;
    /** å¨ææ¥æå¤è¯­èµæº  */
    dynamicLocale?: any;
    /** æ¾ç¤ºä»å¤©ï¼æ¬å¹´ï¼æ¬æ æé® */
    showPresent?: boolean;

    hourStep?: number;
    minuteStep?: number;
    secondStep?: number;

    /** æ¯å¦å¯ç¨å¤é */
    multiSelect?: boolean;
    /** å¤éåéç¬¦ */
    separator?: string;
    /** åè®¸æå¤§éæ©æ¥ææ°éï¼é»è®¤ä¸º0 æ ééæ© */
    maxSelected?: number;
    /** éä¸­çæ¥æåè¡¨æ¯å¦è¿è¡æåºï¼å¯é 'none'|'asc'|'desc', é»è®¤ä¸º â0â å³ä¸å¯ç¨æåº */
    selectedOrderBy?: MultiSelectedOrderBy;
    /** æ¥æå¤éå¤è¯­èµæº */
    multiDatesLocale?: any;

    localeId?: string;
}



 /** æ¥æä¸æ¶é´å±ç¤ºæ¹å¼ï¼switch: è¦ä¹å±ç°æ¥æï¼è¦ä¹å±ç°æ¶é´è§å¾ï¼together: æ¥æä¸æ¶é´ä¸èµ·å±ç°ï¼å·¦ä¾§æ¾ç¤ºæ¥æï¼å³ä¾§æ¾ç¤ºæ¶é´ï¼é»è®¤ä¸º switch */
export enum ViewType {
    Switch = 'switch',
    Together = 'together'
};

export type MultiSelectedOrderBy = 'none'|'asc'|'desc';